import { render } from "./CategoryManageListForm.vue?vue&type=template&id=243cb862&lang=true"
import script from "./CategoryManageListForm.vue?vue&type=script&lang=js"
export * from "./CategoryManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__